import { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const PatientMapRosterTableAddOn = ({
  data = [],
  searchTerm = "",
  loading,
  total,
  page,
  pageSize,
  setPage,
  setPageSize,
  onSelectPatient
}) => {
  const rows = useMemo(() => {
    return data;
  }, [data, searchTerm]);

  const columns = useMemo(() => [
    { field: "PatientName", headerName: "Patient Name", flex: 3, filterable: false },
    { field: "ServiceDate", headerName: "Service Date", flex: 1.5, filterable: false },
    { field: "ProviderName", headerName: "Provider Name", flex: 2, filterable: false },
    {
      field: "WereNotesSigned",
      headerName: "Were Notes Signed",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const value = params.row.WereNotesSigned;
        return value === true ? (
          <Tooltip title="Yes">
            <CheckCircleIcon style={{ color: "green" }} />
          </Tooltip>
        ) : value === false ? (
          <Tooltip title="No">
            <CancelIcon style={{ color: "red" }} />
          </Tooltip>
        ) : null;
      }
    },
    {
      field: "WasChargeSlipComleted",
      headerName: "Was charge slip completed?",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const value = params.row.WasChargeSlipComleted;
        return value === true ? (
          <Tooltip title="Yes">
            <CheckCircleIcon style={{ color: "green" }} />
          </Tooltip>
        ) : value === false ? (
          <Tooltip title="No">
            <CancelIcon style={{ color: "red" }} />
          </Tooltip>
        ) : null;
      }
    },
    { field: "Name", headerName: "Name", flex: 3, filterable: false },
    { field: "TimeStamp", headerName: "Time Stamp", flex: 3, filterable: false },
  ], [onSelectPatient]);

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ minWidth: "2500px" }}>
        <DataGrid
          getRowId={(row) => crypto.randomUUID()}
          rows={rows}
          columns={columns}
          rowCount={total}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          disableColumnFilter
          disableColumnSelector
          loading={loading}
          onRowClick={(params) => onSelectPatient(params.row)}
        />
      </div>
    </div>
  );
};

export default PatientMapRosterTableAddOn;
